<script setup>
//130
const props = defineProps(['categories']);
const { locale, t } = useI18n();

const localePath = useLocalePath();

const uniqeCategories = (categories) => {
  // remove 15 category if 14 & 15 exist, getCategoryRoute set for 14 & 15 same address
  if (categories.find((c) => c.id == 14) && categories.find((c) => c.id == 15)) {
    categories?.splice(
      categories.findIndex((i) => i.id === 15),
      1
    );
  }
  return categories;
};

const getCategoryRoute = (category) => {
  const slug = category.slug[locale];
  let goTo = null;

  // exposition category
  if (category.id == 3) {
    // KOMENTOVANÉ PROHLÍDKY
    goTo = {
      name: 'education-tours',
    };
  } else if (category.id == 4) {
    // Přednášky a diskuze
    goTo = {
      name: 'education-talks',
    };
  } else if (category.id == 5) {
    // Výtvarné dílny a ateliéry
    goTo = {
      name: 'education-workshops',
    };
  } else if (category.id == 6) {
    // Kurzy dějin umění
    goTo = {
      name: 'education-courses',
    };
  } else if (category.id == 7) {
    // Speciální akce
    goTo = {
      name: 'education-special',
    };
  } else if (category.id == 9) {
    // Herny
    goTo = {
      name: 'education-games',
    };
  } else if (category.id == 10) {
    // Ateliéry
    goTo = {
      name: 'education-kids-workshops',
    };
  } else if (category.id == 11) {
    // Víkend
    goTo = {
      name: 'education-weekend-workshops',
    };
  } else if (category.id == 12) {
    // Letní ateliéry
    goTo = {
      name: 'education-summer-workshops',
    };
  } else if (category.id == 14) {
    // PROGRAMY KE SBÍRKOVÝM EXPOZICÍM
    goTo = {
      name: 'education-schools', // event-exposition
    };
  } else if (category.id == 15) {
    // Programy k výstavám
    goTo = {
      name: 'education-schools',
    };
  } else if (category.id == 17) {
    // Programy pro pedagogy
    goTo = {
      name: 'education-teachers',
    };
  } else {
    // categoried from education
    educationList.value.children.forEach((children) => {
      if (!goTo) {
        goTo = children.children.find((grandchild) => grandchild.slug[locale] == slug);
      }
    });

    if (goTo) {
      goTo = useGetRoute(goTo);
    }

    // categories from eventCategories
    if (!goTo) {
      goTo = eventCategories.value.find((category) => category.slug[locale] == slug);

      if (goTo) {
        goTo = {
          name: 'events___' + locale,
          params: {
            filter: slug,
          },
        };
      }
    }

    // tags
    if (!goTo) {
      goTo = tags.value.find((tag) => tag.slug[locale] == slug);

      if (goTo) {
        goTo = {
          name: 'events___' + locale,
          params: {
            filter: slug,
          },
        };
      }
    }
  }

  return localePath(goTo);
};
const categoryNameChange = (name) => {
  switch (name) {
    case 'Programy pro pedagogy':
      return 'Pedagogové';
      break;

    case 'Programy ke sbírkovým expozicím':
    case 'Programy k výstavám':
      return 'Školní skupiny';
      break;

    default:
      return name;
  }
};
</script>

<template>
  <div>
    <span v-for="(category, key) in uniqeCategories(categories)" v-if="categories" :key="key"
      ><span v-if="key != 0">, </span
      ><component
        :is="getCategoryRoute(category) ? 'nuxt-link' : 'span'"
        :to="getCategoryRoute(category) ? getCategoryRoute(category) : null"
        :class="{ 'category-link': getCategoryRoute(category) }"
        >{{ categoryNameChange(category.name) }}</component
      >
    </span>
    <span v-else>
      {{ t(`global.event-types.${event.type}`) }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.category-link {
  @include underline-transition(1px);
}
</style>
